import React from 'react';
import { Flex } from '@qga/roo-ui/components';

import type { PackageOption as PackageOptionType } from '@shared/v2/utils/getPackageOptions';
import useSearchQuery from '@shared/v2/hooks/useSearchQuery';

import Modal from '@/v2/components/layout/Modal';
import { UI } from '@/v2/types';
import CampaignInfo from '../../../CampaignInfo';
import RoomOptionDetails from '../../../RoomOptionDetails';

interface MobilePackageDetailsProps {
  packageOptions: PackageOptionType[];
  selectedRoomOption?: UI.RoomOption;
  onClose: () => void;
}

const MobilePackageDetails = ({
  packageOptions,
  selectedRoomOption,
  onClose,
}: MobilePackageDetailsProps) => {
  const { searchQuery } = useSearchQuery();
  const selectedInclusionId = searchQuery?.packageOption;
  const selectedPackage = packageOptions.find(
    (option) => option.id === selectedInclusionId,
  );

  const { matchingOffer } = selectedRoomOption || {};

  return (
    <Modal size="lg" onClose={onClose}>
      <Modal.Header>Package details</Modal.Header>
      <Modal.Body>
        <Flex flexDirection="column" gap="4px" px="5" py="4">
          <CampaignInfo mb="4" />
          {matchingOffer && selectedRoomOption && (
            <RoomOptionDetails
              packageName={selectedPackage?.title}
              offer={matchingOffer}
              roomType={selectedRoomOption.roomType}
            />
          )}
        </Flex>
      </Modal.Body>
    </Modal>
  );
};

export default MobilePackageDetails;
